import Fab from '@material-ui/core/Fab';
import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';
import Swal from 'sweetalert2';
import { LogError } from '../../../AppUtil/AppUtil';
import BuxService from '../../../Service/BuxService';
import UserService from '../../../Service/UserService';
import style from './style.module.css';
import { hot } from 'react-hot-loader';

const CashoutAddBankOptions = ({
	setAddModal,
	classes,
	addIndex,
	currentUser,
	setCurrentUser,
	setBankAccounts,
	bankAccounts
}) => {
	const [placeholderFontColor, setPlaceholerFontColor] = useState('lightgrey');

	const ArrowDown = `${process.env.PUBLIC_URL + 'images/arrow-down.png'}`;
	const ArrowUp = `${process.env.PUBLIC_URL + 'images/arrow-up.png'}`;
	const Close = `${process.env.PUBLIC_URL + 'images/close.png'}`;
	const header = 'Add Bank Account';
	const [bankOptions, setBankOptions] = useState([]);
	const [bank, setBank] = useState();
	const [accountName, setAccountName] = useState('');
	const [accountNumber, setAccountNumber] = useState('');
	const [accountType, setAccountType] = useState('');
	const [isLoading, setIsLoading] = useState(false);

	const fetchBanks = async () => {
		try {
			const response = await BuxService.getBanks();

			if (!response || response.status !== 'success') {
				const msg = response.message || 'Fetch banks request failed';
				throw new Error(msg);
			}

			const banks = [...response['Instapay Banks']];
			const bankOptions = banks.map(d => ({ label: d, value: d }));

			setBankOptions(bankOptions);
		} catch (err) {
			this.toggleLoader();
			LogError(err);
		}
	};

	useEffect(() => {
		fetchBanks();
	}, []);

	const SelectBank = () => {
		// set this up
		const disabled = false;
		const label = 'Bank';
		const onChange = e => {
			setBank(e.value);
		};

		const DropdownIndicator = props => {
			return (
				components.DropdownIndicator && (
					<components.DropdownIndicator {...props}>
						<div
							style={{
								borderRadius: '60%',
								height: '16px',
								width: '16px',
								backgroundColor: 'black',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center'
							}}>
							<img src={ArrowDown} alt="arrow-down" width={15} height={15} />
						</div>
					</components.DropdownIndicator>
				)
			);
		};

		const customStyles = {
			control: (provided, state) => ({
				...provided,
				backgroundColor: state.isFocused ? '#e5e5e5' : '#f5f7f8', // Customize the background color
				border: '1px solid lightgrey',
				height: '45px'
			}),
			option: (provided, state) => ({
				...provided,
				backgroundColor: state.isSelected ? '#d5d5d5' : state.isFocused ? '#e5e5e5' : null, // Customize the option background color
				color: 'black'
			}),
			menu: provided => ({
				...provided,
				backgroundColor: '#f5f7f8' // Customize the menu background color
			})
		};

		return (
			<div>
				<label htmlFor="bank">{label}</label>
				<div style={{ position: 'relative' }}>
					<Select
						disabled={disabled}
						id="bank"
						name="bank"
						value={bankOptions.filter(function (option) {
							return option.value === bank;
						})}
						onChange={onChange}
						options={bankOptions}
						components={{ DropdownIndicator }}
						styles={customStyles}
					/>
				</div>
			</div>
		);
	};

	const SelectAccountType = () => {
		// set this up
		const disabled = false;
		const label = 'Account Type';
		const onChange = e => {
			setPlaceholerFontColor('black');
			setAccountType(e.target.value);
		};

		const accountTypeOptions = [
			{ label: 'Checking', value: 'CH' },
			{ label: 'Current', value: 'CU' },
			{ label: 'Digital', value: 'DI' },
			{ label: 'Saving', value: 'SA' }
		];

		return (
			<div>
				<label htmlFor="bank">{label}</label>
				<div style={{ position: 'relative' }}>
					<select
						className={style.cashoutBankSelect}
						disabled={disabled}
						id="bank"
						name="bank"
						onChange={onChange}
						value={accountType}
						style={{
							height: '45px',
							width: '100%',
							border: 'none',
							outline: 'none',
							backgroundColor: '#F5F7F8',
							color: placeholderFontColor,
							paddingLeft: '10px',
							paddingRight: '10px',
							borderRadius: '3px',
							border: '1px solid lightgrey'
						}}>
						{accountTypeOptions.map((option, index) => (
							<option style={{ color: 'black' }} key={index} value={option.value}>
								{option.label}
							</option>
						))}
					</select>
					<div
						style={{
							position: 'absolute',
							top: '50%',
							right: '10px',
							transform: 'translateY(-50%)',
							marginRight: '5px',
							borderRadius: '60%',
							height: '16px',
							width: '16px',
							backgroundColor: 'black',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center'
						}}>
						<img src={ArrowDown} alt="arrow-down" width={15} height={15} />
					</div>
				</div>
			</div>
		);
	};

	const handleSubmit = async () => {
		setIsLoading(true);

		const bankAccountData = {
			sub_email: currentUser.email,
			account_name: accountName,
			account_number: accountNumber,
			account_type: accountType,
			bank
		};

		try {
			const isDuplicate = bankAccounts.some(b => b.account_number === accountNumber && b.bank === bank);
			if (isDuplicate) throw new Error('Bank account already exists');

			const response = await BuxService.buxCreateBank(bankAccountData);

			if (!response || response.status !== 'success') {
				const msg = response.message || 'Add bank account request failed';
				throw new Error(msg);
			}

			if (addIndex === 0) {
				await UserService.updateUserInfo({
					// bank_account_id: response.bank_account_id,
					first_name: currentUser.first_name,
					last_name: currentUser.last_name,
					bank_account_id: response.bank_account_id,
					account_number: accountNumber,
					bank
				});
			} else {
				await UserService.updateUserInfo({
					// bank_account_id: response.bank_account_id,
					first_name: currentUser.first_name,
					last_name: currentUser.last_name,
					[`bank_account_id_${addIndex + 1}`]: response.bank_account_id,
					[`account_number_${addIndex + 1}`]: accountNumber,
					[`bank_${addIndex + 1}`]: bank
				});
			}

			setBankAccounts(prev => {
				const newBankAccounts = [...prev];
				newBankAccounts[addIndex] = {
					bank,
					account_number: accountNumber,
					bank_account_id: response.bank_account_id,
					bgColor: 'rgb(237, 237, 237)',
					opac: '1',
					inverted: false,
					border: '1px solid lightgrey',
					type: 'cashoutBankOptions',
					styleText: { fontSize: '13px' }
				};
				return newBankAccounts;
			});

			const updatedCurrentUser = await UserService.updateCurrentUser();
			if (updatedCurrentUser.profile) await setCurrentUser(updatedCurrentUser);
			setAddModal(false);

			Swal.fire({
				title: 'Success!',
				allowOutsideClick: false,
				text: 'Bank account added successfully!',
				icon: 'success'
			});
		} catch (err) {
			LogError(err);
			Swal.fire({
				allowOutsideClick: false,
				icon: 'error',
				title: 'Oops...',
				text: err.message
			});
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<section
			style={{
				zIndex: 200,
				backgroundColor: 'white',
				position: 'fixed',
				top: '45%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				borderBottomLeftRadius: '15px',
				borderBottomRightRadius: '15px',
				borderTopLeftRadius: '8px',
				borderTopRightRadius: '8px',
				width: '60vw',
				minWidth: '300px',
				maxWidth: '600px',
				height: '500px',
				overflow: 'hidden'
			}}>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					backgroundColor: '#A0E9FF',
					padding: '10px 24px'
				}}>
				<div>{header}</div>
				<div
					style={{ backgroundColor: '', cursor: 'pointer' }}
					onClick={() => {
						if (isLoading) return;
						setAddModal(false);
					}}>
					<img src={Close} alt="close" height="16px" width="16px" />
				</div>
			</div>
			<div style={{ padding: '20px 24px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
				<div>
					<label htmlFor="cashout-account-name">Account Name</label>
					<input
						style={{
							height: '45px',
							width: '100%',
							border: 'none',
							outline: 'none',
							backgroundColor: '#F5F7F8',
							// color: placeholderFontColor,
							paddingLeft: '10px',
							paddingRight: '10px',
							borderRadius: '3px',
							border: '1px solid lightgrey'
						}}
						value={accountName}
						onChange={e => setAccountName(e.target.value)}
						placeholder="Enter Account Name"
						name="account-name"
						id="cashout-account-name"
					/>
				</div>

				<div>
					<label htmlFor="cashout-account-number">Account Number</label>
					<input
						style={{
							height: '45px',
							width: '100%',
							border: 'none',
							outline: 'none',
							backgroundColor: '#F5F7F8',
							// color: placeholderFontColor,
							paddingLeft: '10px',
							paddingRight: '10px',
							borderRadius: '3px',
							border: '1px solid lightgrey'
						}}
						onChange={e => setAccountNumber(e.target.value)}
						value={accountNumber}
						placeholder="Enter Account Number"
						name="account-number"
						id="cashout-account-number"
					/>
				</div>

				<SelectBank />

				<SelectAccountType />
			</div>
			<div style={{ position: 'relative' }}>
				<Fab
					disabled={!bank || !accountName || !accountNumber || !accountType || isLoading}
					aria-label="add"
					className={classes.submit}
					color="primary"
					onClick={handleSubmit}
					size="small"
					type="submit"
					style={{ position: 'absolute', top: '24px', right: '24px' }}
					variant="extended">
					{isLoading ? 'Submitting...' : 'Add Bank'}
				</Fab>
			</div>
		</section>
	);
};

export default hot(module)(CashoutAddBankOptions);
